import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import { EuiSpacer, EuiCard, EuiFlexGroup, EuiFlexItem } from "@elastic/eui";

export default function LatestArticle() {
  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup
          gutterSize="l"
          direction="row"
          style={{ margin: "0 7px" }}
        >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1440p_Series_CGI_List/Features_Menu/Email/">
                  <StaticImage
                    src="../../../images/1440p_Series_CGI_List/Features_Menu/1440pCGIs-WebUI_Features_Email.png"
                    alt="UltraHD Series (2K+ 1440p & 4K 2160p) CGI List - Features Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Email"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1440p_Series_CGI_List/Features_Menu/FTP/">
                  <StaticImage
                    src="../../../images/1440p_Series_CGI_List/Features_Menu/1440pCGIs-WebUI_Features_FTP.png"
                    alt="UltraHD Series (2K+ 1440p & 4K 2160p) CGI List - Features Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="FTP"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1440p_Series_CGI_List/Features_Menu/IR_Nightvision/">
                  <StaticImage
                    src="../../../images/1440p_Series_CGI_List/Features_Menu/1440pCGIs-WebUI_Features_Nightvision.png"
                    alt="UltraHD Series (2K+ 1440p & 4K 2160p) CGI List - Features Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IR Nightvision"
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup
          gutterSize="l"
          direction="row"
          style={{ margin: "0 7px" }}
        >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1440p_Series_CGI_List/Features_Menu/PTZ-Tour/">
                  <StaticImage
                    src="../../../images/1440p_Series_CGI_List/Features_Menu/1440pCGIs-WebUI_Features_PTZ_Tour.png"
                    alt="UltraHD Series (2K+ 1440p & 4K 2160p) CGI List - Features Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="PTZ-Tour"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1440p_Series_CGI_List/Features_Menu/PTZ/">
                  <StaticImage
                    src="../../../images/1440p_Series_CGI_List/Features_Menu/1440pCGIs-WebUI_Features_PTZ.png"
                    alt="UltraHD Series (2K+ 1440p & 4K 2160p) CGI List - Features Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="PTZ"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1440p_Series_CGI_List/Features_Menu/SD_Card/">
                  <StaticImage
                    src="../../../images/1440p_Series_CGI_List/Features_Menu/1440pCGIs-WebUI_Features_SD.png"
                    alt="UltraHD Series (2K+ 1440p & 4K 2160p) CGI List - Features Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="SD Card"
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup
          gutterSize="l"
          direction="row"
          style={{ margin: "0 7px" }}
        >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1440p_Series_CGI_List/Features_Menu/Status_LEDs/">
                  <StaticImage
                    src="../../../images/1440p_Series_CGI_List/Features_Menu/1440pCGIs-WebUI_Features_Status_LEDs.png"
                    alt="UltraHD Series (2K+ 1440p & 4K 2160p) CGI List - Features Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Status LEDs"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1440p_Series_CGI_List/Features_Menu/Wizard/">
                  <StaticImage
                    src="../../../images/1440p_Series_CGI_List/Features_Menu/1440pCGIs-WebUI_Features_Wizard.png"
                    alt="UltraHD Series (2K+ 1440p & 4K 2160p) CGI List - Features Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Wizard"
            />
          </EuiFlexItem>
          <EuiFlexItem></EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
